import { render, staticRenderFns } from "./accountBalance.vue?vue&type=template&id=6a4608fa&scoped=true&"
import script from "./accountBalance.vue?vue&type=script&lang=js&"
export * from "./accountBalance.vue?vue&type=script&lang=js&"
import style0 from "./accountBalance.vue?vue&type=style&index=0&id=6a4608fa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4608fa",
  null
  
)

export default component.exports